module.exports = {
  label: {
    emailId: 'Email ID',
    mobileNumber: 'Mobile Number',
    gender: 'Gender',
    address: 'Address',
    signature: 'Signature',
     nodata:'----',
    
  }
}